import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import 'antd/dist/antd.css';
import GlobalStyle from './styles/global-styles';
import publicRoutes from './routes/public.route';
import privateRoutes from './routes/private.route';
import { AppStore } from './hooks';
import LayoutAdmin from './components/LayoutAdmin';

function App() {
  function getPublicRoutes() {
    return publicRoutes.map((prop, key) => {
      if (prop.redirect) {
        return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
      } else {
        return (
          <Route
            path={prop.path}
            exact={prop.exact}
            component={prop.component}
            key={key}
          />
        );
      }
    });
  }

  function getPrivateRoutes() {
    return privateRoutes.map((prop, key) => {
      if (prop.redirect) {
        return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
      } else {
        return (
          <Route
            path={prop.path}
            exact={prop.exact}
            component={prop.component}
            key={key}
          />
        );
      }
    });
  }

  const token = localStorage && localStorage.getItem('opentrace_token');
  return (
    <React.Fragment>
      <div className="App">
        <Router>
          {!token ? (
            <Switch>{getPublicRoutes()}</Switch>
          ) : (
            <LayoutAdmin>
              <Switch>{getPrivateRoutes()}</Switch>
            </LayoutAdmin>
          )}
        </Router>
      </div>
    </React.Fragment>
  );
}

const rootElement = document.getElementById('root');

ReactDOM.render(
  <React.Fragment>
    <AppStore.Provider>
      <GlobalStyle />
      <App />
    </AppStore.Provider>
  </React.Fragment>,
  rootElement,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
